import axios from "axios";

// TODO: Consider move this logic back to Rosetta
export async function enableAutoRenew(subscriptionId) {
  const response = await axios.post(`/piano/renew`, {
    subscriptionId
  });
  const {
    code,
    data
  } = response.data;
  return code === 0 && data === true;
}